import Price from '~/libs/Price/Price';

import mapProductDataset from './mapProductDataset';
import mapProductPrice from './mapProductPrice';
import MarketSupply from './MarketSupply';
import Product from './Product';
import ProductSourcePrice from './ProductSourcePrice';
import ProductStatus from './ProductStatus';

export type RawProduct = any;

export default function mapProduct(product: RawProduct): Product {
	return new Product(
		product.id,
		product.brandName,
		product.atc,
		product.marketingAuthorizationHolder,
		product.activeSubstance,
		product.validFrom !== null ? new Date(product.validFrom) : null,
		product.validTo !== null ? new Date(product.validTo) : null,
		product.dosageForm,
		product.dosageStrength,
		product.packageSize,
		product.prices.map(mapProductPrice),
		product.sourcePrices.map(
			(price: { type: string; value: string; currency: string; priority: number }) =>
				new ProductSourcePrice(price.type, new Price(price.value, price.currency), price.priority)
		),
		mapProductDataset(product.dataset),
		new Date(product.includedFrom),
		new ProductStatus(product.status.value, product.status.reasonFields),
		new MarketSupply(
			product.marketSupply.status,
			product.marketSupply.informationPublicSince ? new Date(product.marketSupply.informationPublicSince) : null,
			product.marketSupply.statusDateFrom ? new Date(product.marketSupply.statusDateFrom) : null,
			product.marketSupply.statusDateTo ? new Date(product.marketSupply.statusDateTo) : null
		)
	);
}
